const NAV_THEME_STORAGE_KEY = 'app_nav_theme';

export type NavTheme = 'light' | 'realDark';

export const applyNavTheme = (theme: NavTheme) => {
  if (typeof document === 'undefined') return;
  const dark = theme === 'realDark';
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
};

export const saveNavTheme = (theme: NavTheme) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(NAV_THEME_STORAGE_KEY, theme);
};
